export default function (state, value) {
  state.items = [];
  if (value && value.Items) {
    value.Items.forEach(i => {
      state.items.push({
        value: i.Id,
        label: i.Number,
        ...i,
      });
    })
  }
  state.ExportReportUrlXml = '';
  state.ExportReportUrlXlsx = '';
  if (value.ExportReports) {
    const xml = value.ExportReports.find(i => i.ReportFormat === 'xml');
    state.ExportReportUrlXml = xml ? xml.Url : '';
    const xlsx = value.ExportReports.find(i => i.ReportFormat === 'xlsx');
    state.ExportReportUrlXlsx = xlsx ? xlsx.Url : '';
  }
  state.page = 1;
  state.loading = false;
  state.cbs.forEach(i => {
    i(state);
  });
  state.cbs = [];
}